import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { KeyboardService } from '@freelancer/keyboard';
import { StickyBehaviour, StickyPosition } from '@freelancer/ui/sticky';
import * as Rx from 'rxjs';

/**
 * StickyFooterPosition.ABSOLUTE is only used for
 * fullscreen modals, callout and drawers which is automatically
 * set if fl-sticky-footer is a content child of fl-sticky-footer-wrapper.
 *
 * This is to fix issues in older IOS versions where position fixed
 * elements inside scrollable containers either shakes or hide during scrolling
 */
export enum StickyFooterPosition {
  ABSOLUTE = 'absolute',
  FIXED = 'fixed',
}

@Component({
  selector: 'fl-sticky-footer',
  template: `
    <fl-bit
      *ngIf="position === StickyFooterPosition.FIXED"
      class="StickyFooterContainer"
      [flSticky]="true"
      [flStickyPosition]="StickyPosition.BOTTOM"
      [flStickyBehaviour]="StickyBehaviour.ALWAYS"
    >
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </fl-bit>

    <ng-container *ngIf="position === StickyFooterPosition.ABSOLUTE">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </ng-container>

    <ng-template #content>
      <fl-bit
        class="StickyFooter"
        [ngClass]="{
          IsKeyboardOpen: isKeyboardOpen,
          IsHidden: isKeyboardOpen && hideOnKeyboardActive
        }"
        [attr.data-position]="position"
        [attr.data-box-shadow]="boxShadow"
      >
        <ng-content></ng-content>
      </fl-bit>
    </ng-template>
  `,
  styleUrls: ['./sticky-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StickyFooterComponent implements OnInit, OnDestroy {
  StickyFooterPosition = StickyFooterPosition;
  StickyBehaviour = StickyBehaviour;
  StickyPosition = StickyPosition;

  isKeyboardOpen = false;
  keyboardSubscription?: Rx.Subscription;

  @Input() position = StickyFooterPosition.ABSOLUTE;
  @Input() boxShadow = true;

  // Hide when virtual keyboard is open
  // Note: This only for native apps
  @Input() hideOnKeyboardActive = true;

  constructor(
    private keyboardService: KeyboardService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.keyboardSubscription = this.keyboardService.isOpen().subscribe(val => {
      this.isKeyboardOpen = val;
      this.changeDetectorRef.detectChanges();
    });
  }

  ngOnDestroy() {
    if (this.keyboardSubscription) {
      this.keyboardSubscription.unsubscribe();
    }
  }
}
